module.exports = __webpack_public_path__ + "static/fonts/DIN-Bold.20720c3.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/DIN-Bold.otf
// module id = XQpJ
// module chunks = 1